const updateFilterLegStates = (legIds, nextState, filterLegStates) => {
  return legIds.reduce(
    (legStates, legId) => {
      legStates[legId] = nextState;
      return legStates;
    },
    [...filterLegStates]
  );
};

export default updateFilterLegStates;
